module.exports = __webpack_public_path__ + "img/insert-cheminee.7c4d06f.svg";